import {
  FigureIcon,
  HeartIcon,
  EducationIcon,
  TargetIcon,
  EyeIcon,
  HandIcon,
  UncategorizedIcon,
  FullArrowUpTopRightIcon,
  OccurrenceIcon,
  MessageInfoOutlineIcon,
  TwoPersonIcon,
  PersonGoalsIcon,
  Figure2Icon,
  AggressionIcon,
  CubeIcon,
  HookIcon,
  LockOpenedIcon,
  VacationIcon,
  PuzzleIcon,
  RepeatIcon,
  MedicalPlusIcon
} from '@viveaesthetics/shared'
import React from 'react'

export const WORKING_STYLE_ICON_MAP: Partial<Record<string, JSX.Element>> = {
  Affirming: (
    <UncategorizedIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  Approachable: (
    <FigureIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  Attentive: (
    <MessageInfoOutlineIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  Calm: (
    <HookIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  Collaborative: (
    <TwoPersonIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  Compassionate: (
    <PersonGoalsIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  Creative: (
    <Figure2Icon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  Direct: (
    <FullArrowUpTopRightIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  Encouraging: (
    <AggressionIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  Empowering: (
    <OccurrenceIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  Empathetic: (
    <HandIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  Flexible: (
    <CubeIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  Holistic: (
    <OccurrenceIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  Intelligent: (
    <EducationIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  'Non-judgemental': (
    <LockOpenedIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  'Open-minded': (
    <EyeIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  Patient: (
    <VacationIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  Respectful: (
    <PuzzleIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  Reflective: (
    <RepeatIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  'Solution-oriented': (
    <TargetIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  Trustworthy: (
    <MedicalPlusIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  Warm: (
    <HeartIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  Insightful: (
    <HandIcon
      size="icon16"
      $color="iconSecondary"
    />
  ),
  Supportive: (
    <TwoPersonIcon
      size="icon16"
      $color="iconSecondary"
    />
  )
}
